module.exports = Promise.resolve(module.bundle.root("fr27i"))